// zeroLabs Startseite: Awards, der Lauf (sections/zl-start-awards.liquid, assets/zl-start-awards.css).
// Kommt die Bühne ins Bild (Oberkante der Überschrift bei --zl-auftritt-start der Bildschirmhöhe, wie beim Auftritt von Text),
// zählt die Überschrift einmal hoch: Einmal, Zweimal, ... bis zur Überschrift am Ende. Jeder Schritt steht
// --zl-aw-lauf-schritt, jede Zahl gleitet weich herein, das Siegel blendet zu der gezählten Auszeichnung, am Ende setzt sich der Gesamtsieg.
// Aus dem Bild gescrollt oder im Hintergrund wartet der Lauf. Er läuft genau einmal. Steht die Bühne beim Laden schon im
// Bild oder darüber, steht das Ende. Ohne Skript, bei reduzierter Bewegung und ohne IntersectionObserver ebenso.
(() => {
  const html = document.documentElement;
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (still.matches || !('IntersectionObserver' in window)) return;
  // Zeiten mit Einheit lesen: Shopify verkleinert die CSS-Datei und schreibt 550ms dabei als .55s
  const wert = (name) => {
    const roh = getComputedStyle(html).getPropertyValue(name).trim();
    const zahl = parseFloat(roh);
    return /\ds$/.test(roh) && !/ms$/.test(roh) ? zahl * 1000 : zahl;
  };

  const teile = (titel) => {
    const buehne = titel.closest('.zl-aw');
    return {
      schritte: [...titel.querySelectorAll('[data-zl-aw-schritt]')],
      siegel: buehne ? [...buehne.querySelectorAll('[data-zl-aw-siegel]')] : [],
      stufen: buehne ? [...buehne.querySelectorAll('[data-zl-aw-n]')] : [],
      buehne,
    };
  };
  // Die vorige Zahl bekommt "war" und gleitet nach oben weg, die gezählte gleitet von unten herein.
  // Siegel: die gezählte Fassung zeigt sich. Wand und Etiketten: jede Medaille bis zur gezählten setzt sich an ihren Platz.
  const stellen = (titel, s) => {
    const { schritte, siegel, stufen } = teile(titel);
    schritte.forEach((el, j) => {
      if (el.classList.contains('ist-dran') && j !== s) el.classList.add('war');
      el.classList.toggle('ist-dran', j === s);
    });
    siegel.forEach((el) => { el.dataset.zeigt = schritte[s].dataset.typ; });
    stufen.forEach((el) => el.classList.toggle('ist-da', Number(el.dataset.zlAwN) <= s));
  };
  // Anfang des Laufs vor dem ersten Bild: erste Zeile, ihr Siegel. So springt beim Auslösen nichts um.
  const anfang = (titel) => {
    const { schritte, buehne } = teile(titel);
    if (!schritte.length || !buehne) return false;
    titel.classList.add('laeuft');
    buehne.dataset.laeuft = '';
    stellen(titel, 0);
    return true;
  };

  const starten = (titel) => {
    const { schritte, siegel, stufen, buehne } = teile(titel);
    const takt = wert('--zl-aw-lauf-schritt') || 550; // token-ok: Ersatz, falls der Token fehlt
    let sichtbar = true;
    const auge = new IntersectionObserver((e) => { sichtbar = e[0].isIntersecting; });
    auge.observe(buehne);
    let s = 0;
    const weiter = () => {
      if (document.hidden || !sichtbar) { setTimeout(weiter, takt / 4); return; }
      s += 1;
      if (s >= schritte.length) {
        // Ende: die Überschrift steht, der Gesamtsieg landet
        schritte.forEach((el) => { if (el.classList.contains('ist-dran')) el.classList.add('war'); el.classList.remove('ist-dran'); });
        titel.classList.remove('laeuft');
        siegel.forEach((el) => { el.classList.add('ist-gelandet'); delete el.dataset.zeigt; });
        stufen.forEach((el) => el.classList.add('ist-da', 'ist-gelandet'));
        delete buehne.dataset.laeuft;
        auge.disconnect();
        return;
      }
      stellen(titel, s);
      setTimeout(weiter, takt);
    };
    setTimeout(weiter, takt);
  };

  // Das Band reicht von der Auslöselinie weit nach oben, wie beim Auftritt von Text: Wer in einem Sprung darüber
  // hinwegscrollt, löst trotzdem aus und findet beim Zurückscrollen keinen stehengebliebenen Anfang.
  const start = wert('--zl-auftritt-start') || 1;
  const beobachter = new IntersectionObserver((eintraege) => {
    eintraege.filter((e) => e.isIntersecting).forEach((e) => { beobachter.unobserve(e.target); starten(e.target); });
  }, { rootMargin: `10000% 0px -${Math.round((1 - start) * 100)}% 0px` }); // token-ok: Band nach oben offen, 100 Bildschirmhöhen

  const los = () => document.querySelectorAll('[data-zl-aw-lauf]').forEach((t) => {
    if (t.getBoundingClientRect().top < window.innerHeight * start) return;
    if (anfang(t)) beobachter.observe(t);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los);
  else los();
})();
